import { render, staticRenderFns } from "./CriterioInputCategories.vue?vue&type=template&id=0c5f0cde"
import script from "./CriterioInputCategories.vue?vue&type=script&lang=js"
export * from "./CriterioInputCategories.vue?vue&type=script&lang=js"
import style0 from "./CriterioInputCategories.vue?vue&type=style&index=0&id=0c5f0cde&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports